"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useUvsTimedOut = require("./useUvsTimedOut");
Object.keys(_useUvsTimedOut).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useUvsTimedOut[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useUvsTimedOut[key];
    }
  });
});